module.exports = __webpack_public_path__ + "img/jeremy-pro.d7bf1765.jpg";